import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  key: 1,
  class: "section content-container"
}
const _hoisted_3 = { class: "container is-fluid" }
const _hoisted_4 = { class: "columns" }
const _hoisted_5 = { class: "column" }
const _hoisted_6 = { class: "island" }
const _hoisted_7 = { class: "level" }
const _hoisted_8 = { class: "level-right" }
const _hoisted_9 = { class: "level-item" }
const _hoisted_10 = { class: "level-item" }
const _hoisted_11 = { class: "table is-fullwidth" }
const _hoisted_12 = { class: "icon-column" }
const _hoisted_13 = { class: "icon-column" }
const _hoisted_14 = { class: "icon draggable" }
const _hoisted_15 = { class: "icon-column trigger-icon" }
const _hoisted_16 = { class: "icon" }
const _hoisted_17 = {
  key: 0,
  class: "custom-icon"
}
const _hoisted_18 = ["xlink:href"]
const _hoisted_19 = { class: "has-text-right stat started" }
const _hoisted_20 = { class: "has-text-right stat engaged" }
const _hoisted_21 = { class: "has-text-right stat completed" }
const _hoisted_22 = {
  id: "drop-down-menu",
  class: "menu-icon action"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "label" }

import Draggable from 'vuedraggable';
import { UpdateBotFlowsPriorityViewModel } from '@/features/bots/models/request/updateBotFlowsPriorityViewModel';
import { FlowListItemViewModel } from '@/features/bots/models/flowListItemViewModel';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import Modal from '@/shared/components/Modal.vue';
import { AvailableTriggers, FlowViewModel } from '@/features/bots/models/designer';
import Toast from '@/shared/services/toast';
import { exportFlowHelper } from '@/features/bots/services/exportFlow';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import DragIcon from '@/shared/components/DragIcon.vue';
import Button from '@/shared/designsystem/components/control/button/button.vue';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';
import CloneIcon from 'vue-material-design-icons/ContentCopy.vue';
import ExportIcon from 'vue-material-design-icons/Export.vue';
import DeleteIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import { LOAD_FLOWS } from '@/store/bot-designer/actionTypes';
import AddFlowModal from '@/shared/components/AddFlowModal.vue';
import { flowsApi } from '@/features/bots/services/flows';
import appInsights from '@/shared/services/appInsights';
import { SET_FLOWS } from '@/store/bot-designer/mutationTypes';
import { useStore } from 'vuex';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

const flowPriorityTooltip = `Order your flows by priority.
<br/><br/>
If multiple flows share the same trigger conditions, the one with the highest priority will be shown to visitors.
<br/><br/>
If none of the flows are triggered, a bot task will respond instead.`;


export default /*@__PURE__*/_defineComponent({
  __name: 'BotFlows',
  setup(__props) {

const router = useRouter();

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);

const loadFlows = (forceLoad: boolean = false) => store.dispatch(LOAD_FLOWS, forceLoad);
const setFlows = (flows: FlowListItemViewModel[]) => store.commit(SET_FLOWS, flows);

const loading = ref(false);
const showModal = ref(false);
const showDeleteModal = ref(false);
const flowName = ref('');
const flowToDelete = ref<FlowListItemViewModel>();
const botFlows = ref<FlowListItemViewModel[]>([]);
const importFlowButton = ref<typeof Button | null>(null);

onMounted(() => getBotFlows());

async function updatePriorities() {
  setPriorities();
  const request = createUpdateFlowsPrioritiesRequest();
  const updateBotFlows: UpdateBotFlowsPriorityViewModel = {
    flows: request,
  };
  await flowsApi.updateFlows(currentWorkspace.value.id, updateBotFlows);
  setFlows(botFlows.value);
}

function addFlow() {
  showModal.value = true;
  flowName.value = '';
}

function chooseFlow(flow: FlowListItemViewModel, created = false) {
  router.push({ name: 'bots-flow-designer', params: { flowId: flow.id }, query: { created: created.toString() } });
}

function onFileChange(event: any) {
  appInsights.trackEvent({ name: 'Import flow clicked' }, { workspaceId: currentWorkspace.value.id });
  const files = event.target.files;
  if (!files.length) {
    Toast.showError('No file selected');
    throw new Error('No file selected');
  }
  const file = event.target.files[0];
  handleFlowFile(file);
}

function handleFileLoad(event: any) {
  try {
    const botFlowAsJson = JSON.parse(event.target.result);
    importFlow(currentWorkspace.value.id, botFlowAsJson);
  } catch (e) {
    Toast.showError('The file must contain valid JSON');
  }
}

async function deleteFlow(flow: FlowListItemViewModel) {
  try {
    const fullFlowDetails = await flowsApi.getFlow(currentWorkspace.value.id, flow.id);
    if (!fullFlowDetails) {
      Toast.showError(`Unable to delete ${flow.name}`);
      return;
    }

    if (isTransitionedTo(fullFlowDetails)) {
      Toast.showError('Cannot delete a flow that is transitioned to by another flow or FAQ');
    } else {
      flowName.value = '';
      flowToDelete.value = flow;
      showDeleteModal.value = true;
    }
  } catch {
    Toast.showError(`Unable to delete ${flow.name}`);
  }
}

async function cloneFlow(flow: FlowListItemViewModel, index: number) {
  try {
    appInsights.trackEvent({ name: 'Clone flow clicked' }, { workspaceId: currentWorkspace.value.id, flowId: flow.id });
    const clonedFlow = await flowsApi.cloneFlow(currentWorkspace.value.id, flow.id);
    insertInBotFlows(index + 1, clonedFlow);
    await updatePriorities();
    Toast.showSuccess('Successfully cloned flow');
  } catch {
    Toast.showError('Error duplicating flow');
  }
}

function openFileSelector() {
  importFlowButton.value?.click();
}

async function deleteFlowConfirm() {
  if (!flowToDelete.value) return;

  appInsights.trackEvent({ name: 'Delete flow clicked' });
  showDeleteModal.value = false;
  try {
    await flowsApi.deleteFlow(currentWorkspace.value.id, flowToDelete.value.id);
    botFlows.value = botFlows.value.filter((botflow: FlowListItemViewModel) => botflow.id !== flowToDelete.value?.id);
    setFlows(botFlows.value);
    Toast.showSuccess(`Successfully deleted ${flowToDelete.value.name}`);
  } catch (e) {
    Toast.showError(`Unable to delete ${flowToDelete.value.name}`);
  }
}

function getTriggerDescription(flow: FlowListItemViewModel) {
  const trigger = getTriggerItem(flow);
  if (!trigger) {
    return 'None';
  }
  return trigger.description;
}

function getTriggerIcon(flow: FlowListItemViewModel) {
  const trigger = getTriggerItem(flow);
  if (!trigger) {
    return '';
  }
  return trigger.icon;
}

async function exportFlow(flow: FlowListItemViewModel) {
  try {
    await exportFlowHelper.exportFlow(currentWorkspace.value.id, flow.id);
  } catch (e) {
    Toast.showError(`There was a problem exporting ${flow.name}`);
  }
}

function calculatePercentage(value: number, total: number) {
  if (!total) {
    return 0;
  }
  return Math.round((value / total) * 100);
}

function createUpdateFlowsPrioritiesRequest() {
  return botFlows.value.map((flow: FlowListItemViewModel) => ({ id: flow.id, priority: flow.priority }));
}

function insertInBotFlows(index: number, flow: FlowListItemViewModel) {
  botFlows.value.splice(index, 0, flow);
}

function getTriggerItem(flow: FlowListItemViewModel) {
  if (flow.triggers.length === 0) {
    return null;
  }

  return AvailableTriggers.get(flow.triggers[0]);
}

function handleFlowFile(file: any) {
  if (file.type === 'application/json') {
    const reader = new FileReader();
    reader.onload = handleFileLoad;
    reader.readAsText(file);
  } else {
    Toast.showError('File must be JSON');
  }
}

async function importFlow(botId: string, botFlow: string) {
  try {
    const importedFlow = await flowsApi.importFlow(botId, { flow: botFlow });
    botFlows.value.push(importedFlow);
    router.push({ name: 'bots-flow-designer', params: { flowId: importedFlow.id } });
    Toast.showSuccess('File imported successfully');
  } catch (e: any) {
    if (e.status === 409) {
      Toast.showError(e.message);
      return;
    }
    Toast.showError('The Flow you imported is not valid');
  }
}

function setPriorities() {
  for (let i = 0; i < botFlows.value.length; i++) {
    botFlows.value[i].priority = botFlows.value.length - i;
  }
}

async function getBotFlows() {
  loading.value = true;
  try {
    const botFlowDataPromise = loadFlows(true);
    const loadedBotFlows: FlowListItemViewModel[] = await botFlowDataPromise;
    loadedBotFlows.sort((first, second) => second.priority - first.priority);
    botFlows.value = loadedBotFlows;
  } finally {
    loading.value = false;
  }
}

function isTransitionedTo(fullFlowDetails: FlowViewModel) {
  return hasFlowParent(fullFlowDetails) || hasAnswerParent(fullFlowDetails);
}

function hasFlowParent(fullFlowDetails: FlowViewModel) {
  return fullFlowDetails.parentFlows.length > 0;
}

function hasAnswerParent(fullFlowDetails: FlowViewModel) {
  return fullFlowDetails.parentAnswers.length > 0;
}

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_n_badge = _resolveComponent("n-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createBlock(_component_n_loading_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("nav", _hoisted_7, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "level-left" }, null, -1)),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, [
                        _createVNode(_component_n_button, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (addFlow())),
                          variant: "primary"
                        }, {
                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createElementVNode("span", null, "Add Flow", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _createElementVNode("p", _hoisted_10, [
                        _createVNode(_component_n_button, {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (openFileSelector())),
                          variant: "primary"
                        }, {
                          default: _withCtx(() => [
                            _cache[9] || (_cache[9] = _createElementVNode("span", null, "Import flow", -1)),
                            _createElementVNode("input", {
                              ref_key: "importFlowButton",
                              ref: importFlowButton,
                              id: "file-picker",
                              type: "file",
                              accept: ".json",
                              onChange: onFileChange
                            }, null, 544)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("table", _hoisted_11, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_12, [
                          _createVNode(_component_n_tooltip, {
                            position: "bottom",
                            text: flowPriorityTooltip,
                            offset: 2
                          })
                        ]),
                        _cache[11] || (_cache[11] = _createElementVNode("th", { class: "icon-column" }, " ", -1)),
                        _cache[12] || (_cache[12] = _createElementVNode("th", null, "Name", -1)),
                        _cache[13] || (_cache[13] = _createElementVNode("th", { class: "status-column" }, "Status", -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("th", { class: "has-text-right count-percent-column" }, "Started", -1)),
                        _cache[15] || (_cache[15] = _createElementVNode("th", { class: "has-text-right count-percent-column" }, "Engaged", -1)),
                        _cache[16] || (_cache[16] = _createElementVNode("th", { class: "has-text-right count-percent-column" }, "Completed", -1)),
                        _cache[17] || (_cache[17] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createVNode(_unref(Draggable), {
                      id: "flows-list",
                      onEnd: updatePriorities,
                      modelValue: botFlows.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((botFlows).value = $event)),
                      tag: "tbody",
                      "item-key": "id"
                    }, {
                      item: _withCtx(({ element: flow, index }) => [
                        (_openBlock(), _createElementBlock("tr", {
                          class: "flow-row",
                          key: flow.id
                        }, [
                          _createElementVNode("td", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, [
                              _createVNode(DragIcon, {
                                color: "#A9A9A9",
                                class: "icon-1-5x draggable"
                              })
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_15, [
                            _createVNode(_component_n_tooltip, {
                              position: "bottom",
                              text: 'Trigger: ' + getTriggerDescription(flow)
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_16, [
                                  (getTriggerIcon(flow).startsWith('#'))
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_17, [
                                        _createElementVNode("use", {
                                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                          "xlink:href": `${getTriggerIcon(flow)}`
                                        }, null, 8, _hoisted_18)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (!getTriggerIcon(flow).startsWith('#') && getTriggerIcon(flow))
                                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                        key: 1,
                                        icon: ['far', getTriggerIcon(flow)]
                                      }, null, 8, ["icon"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["text"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_router_link, {
                              to: { name: 'bots-flow-designer', params: { flowId: flow.id } }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(flow.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _createElementVNode("td", null, [
                            (flow.status === 'live')
                              ? (_openBlock(), _createBlock(_component_n_badge, {
                                  key: 0,
                                  variant: "success"
                                }, {
                                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                                    _createTextVNode("Live")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (flow.status === 'paused')
                              ? (_openBlock(), _createBlock(_component_n_badge, {
                                  key: 1,
                                  variant: "secondary"
                                }, {
                                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                                    _createTextVNode("Paused")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (flow.status === 'draft')
                              ? (_openBlock(), _createBlock(_component_n_badge, {
                                  key: 2,
                                  variant: "default"
                                }, {
                                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                                    _createTextVNode("Draft")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_19, _toDisplayString(flow.startedCount || 0), 1),
                          _createElementVNode("td", _hoisted_20, _toDisplayString(calculatePercentage(flow.engagedCount, flow.startedCount)) + "% ", 1),
                          _createElementVNode("td", _hoisted_21, _toDisplayString(calculatePercentage(flow.completedCount, flow.startedCount)) + "% ", 1),
                          _createElementVNode("td", _hoisted_22, [
                            _createVNode(DropDownMenu, {
                              goLeft: true,
                              dropDownIcon: "dots"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  id: "export-flow-button",
                                  onClick: ($event: any) => (exportFlow(flow)),
                                  class: "dropdown-item"
                                }, [
                                  _createVNode(ExportIcon),
                                  _cache[21] || (_cache[21] = _createTextVNode(" Export "))
                                ], 8, _hoisted_23),
                                _createElementVNode("a", {
                                  id: "clone-flow-button",
                                  onClick: ($event: any) => (cloneFlow(flow, index)),
                                  class: "dropdown-item"
                                }, [
                                  _createVNode(CloneIcon),
                                  _cache[22] || (_cache[22] = _createTextVNode(" Clone "))
                                ], 8, _hoisted_24),
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (deleteFlow(flow)),
                                  class: "dropdown-item"
                                }, [
                                  _createVNode(DeleteIcon),
                                  _cache[23] || (_cache[23] = _createTextVNode(" Delete "))
                                ], 8, _hoisted_25)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  (showModal.value)
                    ? (_openBlock(), _createBlock(AddFlowModal, {
                        key: 0,
                        onClose: _cache[3] || (_cache[3] = ($event: any) => (showModal.value = false)),
                        onFlowAdded: _cache[4] || (_cache[4] = (flow) => chooseFlow(flow, true))
                      }))
                    : _createCommentVNode("", true),
                  (showDeleteModal.value)
                    ? (_openBlock(), _createBlock(Modal, {
                        key: 1,
                        onCancel: _cache[7] || (_cache[7] = ($event: any) => (showDeleteModal.value = false))
                      }, {
                        title: _withCtx(() => _cache[24] || (_cache[24] = [
                          _createElementVNode("p", { class: "modal-card-title" }, "Delete Flow", -1)
                        ])),
                        body: _withCtx(() => [
                          _createElementVNode("label", _hoisted_26, [
                            _cache[25] || (_cache[25] = _createTextVNode("Are you sure you want to delete the ")),
                            _createElementVNode("b", null, _toDisplayString(flowToDelete.value?.name), 1),
                            _cache[26] || (_cache[26] = _createTextVNode(" flow? The action is irreversible. Please type the name of the flow to confirm:"))
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            class: "input",
                            type: "text",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((flowName).value = $event))
                          }, null, 512), [
                            [_vModelText, flowName.value]
                          ])
                        ]),
                        buttons: _withCtx(() => [
                          _createVNode(_component_n_button, {
                            disabled: flowName.value !== flowToDelete.value?.name,
                            variant: "primary",
                            onClick: deleteFlowConfirm
                          }, {
                            default: _withCtx(() => _cache[27] || (_cache[27] = [
                              _createTextVNode("Delete")
                            ])),
                            _: 1
                          }, 8, ["disabled"]),
                          _createVNode(_component_n_button, {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (showDeleteModal.value = false))
                          }, {
                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                              _createTextVNode("Cancel")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})